import Logo from '../../../assets/images/ft_logo.png';
import ft_icon1 from '../../../assets/images/ft_icon1.png';
import ft_icon2 from '../../../assets/images/ft_icon2.png';
import ft_icon3 from '../../../assets/images/ft_icon3.png';

export default function Footer() {
  return (
    <>
      <footer>
        <div className=" ft ">
          <div className="center row-flex between m-col-flex t-col-flex">
            <div className="col-flex w-50 txt-left m-w-100 t-w-100">
              <div className="ft_logo mb-4 pointer" onClick="location=''">
                <img src={Logo} alt="" />
              </div>
              <div className="row-flex-center gap-20 mb-10 prt-regular fs-20 fc-64">
                <a href="/">공식홈페이지</a>
                <a href="/sub6_1">고객센터</a>
              </div>

              <div className="ft_icons row-flex-center gap-20">
                <a href="https://blog.naver.com/bomembers" target='_blank' className="flex-center">
                  <img src={ft_icon1} alt="" />
                </a>
                <a href="https://www.instagram.com/creambot.ai"  target='_blank'  className="flex-center">
                  <img src={ft_icon2} alt="" />
                </a>
                <a href="https://youtube.com/@creambot_ai?feature=shared" target='_blank'  className="flex-center">
                  <img src={ft_icon3} alt="" />
                </a>
              </div>
            </div>
            <div
              className="w-50 flex align-end 
            justify-end ws-nowrap m-w-100 m-flex-start m-ws-wrap  t-flex-start t-ws-wrap"
            >
              <div
                className="col-flex w-80 
              fc-64 prt-regular fs-18 lh-17
            txt-left m-w-100 t-w-100"
              >
                {/* <div className="row-flex m-col-flex m-mt-20 t-mt-20">
                  <span className="prt-bold">운영본부: </span>
                  <span>
                    서울특별시 강서구 강서로 56가길 41, 2층 201호 (등촌동,
                    민경빌딩)
                  </span>
                </div> */}
                <div className="row-flex">
                  <span className="prt-bold">본사</span>
                  {/* <span>: 인천광역시 서구 이음 4로 10, 518-521호</span> */}
                  <span>: 인천 서구 로봇랜드로 155-11 1306호</span>
                </div>
                <div className="row-flex">
                  <span className="prt-bold">상호</span>
                  <span>: 주식회사 크림봇 </span>
                </div>
                <div className="row-flex">
                  <span className="prt-bold">사업자등록번호</span>
                  <span> : 501-81-31378 &nbsp;</span>
                  <span className="prt-bold">대표자</span>{' '}
                  <span>: 김찬영 </span>
                </div>
                <div className="row-flex">
                  <span className="prt-bold">TEL</span>
                  <span> : 1555-3811 &nbsp;</span>
                  <span className="prt-bold"> E-mail</span>
                  <span>: bomembers@naver.com </span>
                </div>
                <span className="fs-14">
                  © 2025 Creambot. All Rights Reserved.
                </span>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
